export const ATS_PUBLIC_CAREER_SITE = 'ATS_PUBLIC_CAREER_SITE';
